import React from 'react';
import cx from 'classnames';
import Button from '../../atoms/Button';
import IconButtonProps, { IconButtonVariety, IconDirection } from './IconButton.types';
import styles from './IconButton.module.scss';
import Icon from '../../atoms/Icon';

const IconButton = ({
  disabled = false,
  variety = IconButtonVariety.Square,
  text,
  onClick,
  icon,
  className,
  dataCy = 'iconButton',
  trackingLabel = null,
  label,
  iconDirection = IconDirection.LEFT,
  blackBoldText,
}: IconButtonProps) => {
  const getIconElement = (): React.ReactNode => (
    <div className={styles.iconWrapper}>
      <Icon {...icon} />
    </div>
  );

  return (
    <Button
      variant='icon'
      className={cx(styles.iconButton, styles[variety], className)}
      disabled={disabled}
      onClick={onClick}
      data-cy={dataCy}
      aria-label={label}
      trackingLabel={trackingLabel}>
      {iconDirection === IconDirection.LEFT && getIconElement()}
      <div className={cx(styles.text, { [styles.blackBoldText]: blackBoldText })}>{text}</div>
      {iconDirection === IconDirection.RIGHT && <span className={styles.iconLeftGap}>{getIconElement()}</span>}
    </Button>
  );
};

export default IconButton;
